import { useCallback } from "react";

import type { SdkContentType } from "app/pages/sales-intelligence/domain/sdk/types/filter-values";
import { sdkContentTypeMap } from "app/pages/sales-intelligence/domain/sdk/types/filter-values";
import { toggleName } from "app/pages/sales-intelligence/domain/sdk/utils/descriptions";
import type { AppsSdksSignalSelection } from "app/pages/sales-intelligence/domain/signals/types/apps-signal";

export type SdksFilterItem = {
    readonly name: string;
    readonly type: SdkContentType;
};

type HookValue = {
    onItemClick(item: Readonly<SdksFilterItem>): void;
};

/**
 * Categories and SDK names live in two sibling lists of one selection, so every
 * toggle has to emit both lists — a partial patch would drop the untouched one.
 */
const useSdksFilterState = (
    selectedValue: Readonly<AppsSdksSignalSelection>,
    onValueChange: (value: AppsSdksSignalSelection) => void,
): HookValue => {
    const handleItemClick = useCallback(
        ({ name, type }: Readonly<SdksFilterItem>): void => {
            const sdks = selectedValue.sdks ?? [];
            const sdkCategories = selectedValue.sdkCategories ?? [];

            if (type === sdkContentTypeMap.category) {
                onValueChange({ sdks, sdkCategories: toggleName(sdkCategories, name) });

                return;
            }

            onValueChange({ sdks: toggleName(sdks, name), sdkCategories });
        },
        [onValueChange, selectedValue],
    );

    return { onItemClick: handleItemClick };
};

export default useSdksFilterState;
